<template>
    <div class="date-time-range">
      <el-date-picker
        style="position: relative;top: 3px;width:360px;"
        v-model="value"
        type="datetimerange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        @change="changeDateTime"
        align="right">
      </el-date-picker>
    </div>
</template>
<script>
import utils from '@/utils';

export default {
  name: 'dateTimeRange',
  data() {
    return {
      value: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  methods: {
    changeDateTime() {
      if (!this.value || this.value === 0) {
        return;
      }
      let obj = {
        startDate: utils.getTime(this.value[0]),
        endDate: utils.getTime(this.value[1])
      };
      this.$emit('changeDateTime', obj);
    }
  }
};
</script>
<style lang="scss" >
.date-time-range{
  position: relative;
  top: -3px;
}

</style>
